/**
 * +81から始まる国際表記を0始まりの国内表記に変換
 */
export const toDomestic = (phone: string) =>
  phone && phone.startsWith('+81') ? '0' + phone.slice(3) : phone || ''

/**
 * 国内表記の0から始まる電話番号を+81の国際表記に変換
 */
export const toInternational = (phone: string) =>
  phone && phone.startsWith('0') ? '+81' + phone.slice(1) : phone || ''
